import { Card, Grid, Input, Typography } from "@mui/material";
import { useEffect, } from "react";
import { useReducer, useState } from "react";
import moment from "moment";
import useFetch from "../hooks/useFetch";
import Form, { FormActions } from "../components/Form";
import { DETAILS_APIS, MANAGEMENT_APIS, MASTER_DATA_APIS } from "../common/apis";
import FormFooter from "../components/FormFooter";
import { toIsoFormat } from "../utils";
import { useToast } from "../rootContext";

export default function SpecialReport() {

  const [data, dispatch] = useReducer(
    SearchFilterReducer,
    SearchFilterDefaults
  );

  const { get, post } = useFetch();
  const [laboratories, setLaboratories] = useState();
  const [reportTypes, setReportTypes] = useState([]);
  const [billingRate, setBillingRate] = useState([]);
  const { showErrorToast } = useToast();

  //call api for search audit data
  const saveClick = async () => {
    let base64Data = null;
    const file = data?.AdHocReport;

    if (file instanceof File) {
      base64Data = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result.split(",")[1]);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    }
    const payload = {
      ReportNumber: data.ReportNumber ?? null,
      AdHocReportTypeId: data.AdHocReportTypeId,
      UnitId: Number(data.UnitId) || null,
      ComponentId: data.ComponentId ?? null,
      Sampled: data.Sampled,
      LaboratoryId: Number(data.LaboratoryId) || null,
      UnitHours: Number(data.UnitHours) || null,
      ComponentHours: Number(data.ComponentHours) || null,
      Hours: Number(data.Hours) || null,
      BillingRate: Number(data.BillingRate) || null,
      Notes: data.Notes,
      JobNumber: data.JobNumber,
      Version: Number(data.Version) || null,
      Extension: file?.name?.split(".")?.pop()?.toLowerCase() ?? "",
      AdHocReport: base64Data ?? null,
      MimeType: file?.type || null,
      IsCMS: !!data.IsCMS,
      IsExternalProvider: !!data.IsExternalProvider,
      IsCustomer: !!data.IsCustomer,
      IsArchived: !!data.IsArchived,
      ShowOnWebsite: !!data.ShowOnWebsite,
      DoRelease: !!data.Released,
      DoExport: !!data.Exported,
      Screen: data.Screen
    };
    var res = await post(MANAGEMENT_APIS.ADD_UPDATE_ADHOC_REPORT, payload);
    if (res > 0) {
      window.close()
      localStorage.removeItem("special-report")
      localStorage.setItem("adhoc-report-refresh", true)
      const treeData = { ProductId: data?.ProductId, StartLetter: data?.StartLetter, CustomerId: data?.CustomerId, SiteId: data?.SiteId || data?.SiteId, UnitId: data?.UnitId, ...(data?.ComponentId != null && { ComponentId: data.ComponentId }), refreshCheck: true }
      localStorage.setItem("tree-resp", JSON.stringify({ ...treeData }));
      window.dispatchEvent(new Event('storage'));
    } else {
      showErrorToast("Something went wrong!")
    }
  }

  const getUnitReport = async (id) => {
    // let responseTrayData = await get(`${MANAGEMENT_APIS.UNIT_ADHOC_REPORT}?unitId=${id}`);
    let responseTrayData = await get(`${DETAILS_APIS.UNIT}?unitId=${id}`);
    dispatch({
      type: FormActions.LOAD_DATA,
      payload: { ...responseTrayData?.Unit },
    });
  }

  const getComponentReport = async (id) => {
    // let responseTrayData = await get(`${MANAGEMENT_APIS.COMPONENT_ADHOC_REPORT}?componentId=${id}`);
    let responseTrayData = await get(`${DETAILS_APIS.COMPONENT}?compId=${id}`);
    dispatch({
      type: FormActions.LOAD_DATA,
      payload: { ...responseTrayData?.Component },
    });
  }
  const getAdHocReport = async (id) => {
    let responseTrayData = await get(`${MANAGEMENT_APIS.GET_ADHOC_REPORT}?reportNumber=${id}`);
    dispatch({
      type: FormActions.LOAD_DATA,
      payload: { ...responseTrayData },
    });
  }

  // const getBillingRate = async () => {
  //   const billingRate = await get(`${MANAGEMENT_APIS.BILLING_RATES}`);
  //   setBillingRate(billingRate);

  // }
  function formatScreenName(path) {
    if (!path) return "";

    // Remove leading slash if present
    const cleanPath = path.startsWith("/") ? path.slice(1) : path;

    return cleanPath
      .split("-") // split by dashes
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" "); // join with spaces
  }
  useEffect(() => {
    (async function () {
      const response = await get(`${MASTER_DATA_APIS.GET_BY_TYPES}?types=Laboratories`);
      const reportTypesList = await get(`${MANAGEMENT_APIS.ADHOC_REPORT_TYPES}`);
      dispatch({
        type: FormActions.INPUT_CHANGED,
        payload: {
          name: "AdHocReportTypeId",
          value: reportTypesList[0]?.AdHocReportTypeId,
        },
      });
      setReportTypes(reportTypesList);
      setLaboratories(response.Laboratories || []);
    })()
    // getBillingRate();
    const screenName = formatScreenName(window.location.pathname);
    dispatch({
      type: FormActions.INPUT_CHANGED,
      payload: {
        name: "Screen",
        value: screenName,
      },
    });
    let le = JSON.parse(localStorage.getItem("special-report"))
    if (le?.ReportNumber) {
      getAdHocReport(le?.ReportNumber)
      document.title = "Edit Special Report"
    } else {
      document.title = "Add Special Report"
    }
    if (le?.UnitId > 0) {
      if (le?.ComponentId > 0) {
        getComponentReport(le?.ComponentId)
      }
      else {
        getUnitReport(le?.UnitId)
      }
    }

  }, []);

  // useEffect(() => {
  //   if (!billingRate || billingRate.length === 0) return;

  //   let newRate;

  //   if (data?.IsShowOnWebsite) {
  //     const matchedRate = billingRate.find(
  //       x => x.IsExternal === data.IsShowOnWebsite
  //     );
  //     newRate = matchedRate?.Cost ?? null;
  //   } else {
  //     newRate = billingRate[0]?.Cost ?? null;
  //   }

  //   if (data?.BillingRate === newRate) return;

  //   dispatch({
  //     type: FormActions.LOAD_DATA,
  //     payload: {
  //       ...data,
  //       BillingRate: newRate
  //     }
  //   });

  // }, [data?.IsShowOnWebsite, billingRate]);

  return (
    <Card sx={{ p: 1 }}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Form
            sections={GetFormSections(data, laboratories, reportTypes, dispatch)}
            data={data}
            dispatch={dispatch}
            key={data._ts_key}
          />
        </Grid>

        <Grid item xs={12}>
          <FormFooter buttons={GetFormButtons(saveClick)} />
        </Grid>
      </Grid>
    </Card>
  );
}

function GetFormSections(data, laboratories, reportTypes, dispatch) {
  return [
    {
      fields: [
        {
          xsCol: 12,
          component: function () {
            return (
              <Typography >
                {`${data?.Product || ""}`}  {`${data?.Customer || ""}`} {`${data?.Site || ""}`}
              </Typography>
            );
          },
        },
        {
          xsCol: 12,
          group: [
            {
              xsCol: 9,
              component: function () {
                return (
                  <Typography >
                    {`${data?.Unit || ""}`}  {`(${data?.UnitModelFormatted || ""})`} {`${data?.Component || ""}`}
                  </Typography>
                );
              },
            },
            {
              name: "ShowOnWebsite",
              label: "Show On Website",
              xsCol: 3,
              type: "switch",
            },
          ],
        },
        {
          xsCol: 12,
          group: [
            {
              name: "AdHocReportTypeId",
              label: "Report Type",
              type: "dropdown",
              xsCol: 3,
              required: true,
              selectOptions: (reportTypes || [])
                ?.map((x) => ({
                  value: x.AdHocReportTypeId,
                  text: x.AdHocReportType,
                })),
            },
            {
              name: "IsArchived",
              label: "Archived",
              xsCol: 3,
              type: "switch",
            },
          ]
        },
        {
          xsCol: 9,
          group: [
            {
              name: "Sampled",
              label: "Reference",
              xsCol: 4,
              type: "datetime",
              disablePast: true,
            },
          ]
        },
        {
          xsCol: 3,
          justifySelf: "right",
          group: [
            {
              name: "UnitHours",
              label: "Unit Hours",
              xsCol: 12,
              type: "number",
            },
          ]
        },
        {
          xsCol: 9,
          group: [
            {
              name: "LaboratoryId",
              label: "Laboratory",
              type: "dropdown",
              xsCol: 4,
              required: true,
              selectOptions: (laboratories || [])
                ?.filter((x) => x?.LaboratoryId !== 0)
                ?.map((x) => ({
                  value: x.LaboratoryId,
                  text: x.Laboratory,
                })),
            },
          ]
        },
        {
          xsCol: 3,
          justifySelf: "right",
          group: [
            {
              name: "ComponentHours",
              label: "Component Hours",
              xsCol: 12,
              type: "number",
            },
          ]
        },
        // {
        //   xsCol: 12,
        //   group: [

        //   ],
        // },
        {
          xsCol: 12,
          group: [
            {
              name: "JobNumber",
              label: "Job No",
              xsCol: 3,
            },
            {
              name: "Version",
              label: "New Version",
              xsCol: 2,
              type: "number",
            },
            // {
            //   name: "BillingRate",
            //   label: "Billing Rate",
            //   xsCol: 2,
            //   type: "number",

            // },
            // {
            //   name: "Hours",
            //   label: "Hours",
            //   xsCol: 2,
            //   type: "number",

            // },
            // {
            //   xsCol: 3,
            //   alignSelf: "flex-end",
            //   component: function () {
            //     return (
            //       <Typography  >
            //         ${(data?.BillingRate * data?.Hours) || "0"}
            //       </Typography>
            //     );
            //   },
            // },
          ],
        },
        {
          xsCol: 12,
          group: [
            {
              xsCol: 3,
              alignSelf: "flex-end",
              component: function () {
                return (
                  <><Input
                    disableUnderline={true}
                    size="large"
                    name="AdHocReport"
                    type="file"
                    onChange={(e) => {
                      const file = e.target.files[0];

                      dispatch({
                        type: FormActions.INPUT_CHANGED,
                        payload: { name: "AdHocReport", value: file },
                      });
                    }}
                  />
                    {/* <Input
                      disableUnderline={true}
                      size="large"
                      name="AdHocReport"
                      type="file"
                      accept=".pdf"
                      onChange={(e) => {
                        const file = e.target.files[0];

                        if (!file) {
                          // Reset error if no file selected
                          dispatch({
                            type: FormActions.INPUT_CHANGED,
                            payload: { name: "AdHocReportError", value: "" },
                          });
                          return;
                        }

                        const isPDF = file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf");
                        if (!isPDF) {
                          // Set error message in state
                          dispatch({
                            type: FormActions.INPUT_CHANGED,
                            payload: { name: "AdHocReportError", value: "Only PDF files are allowed." },
                          });
                          e.target.value = null; // reset input
                          return;
                        }

                        // Clear error and save file
                        dispatch({
                          type: FormActions.INPUT_CHANGED,
                          payload: { name: "AdHocReportError", value: "" },
                        });
                        dispatch({
                          type: FormActions.INPUT_CHANGED,
                          payload: { name: "AdHocReport", value: file },
                        });
                      }}
                    />
                    {data.AdHocReportError && (
                      <Typography color="error" variant="body2">
                        {data.AdHocReportError}
                      </Typography>
                    )} */}
                  </>
                );
              },
            },
          ],
        },
        {
          xsCol: 12,
          group: [
            {
              name: "Released",
              label: "Release",
              xsCol: 1.5,
              type: "switch",
            },
            {
              name: "Exported",
              label: "Export",
              xsCol: 1.5,
              type: "switch",
            },
            {
              name: "IsCMS",
              label: "IsCMS",
              xsCol: 1.5,
              type: "switch",
            },
            {
              name: "IsExternalProvider",
              label: "IsExternalProvider",
              xsCol: 2.5,
              type: "switch",
            },
            {
              name: "IsCustomer",
              label: "IsCustomer",
              xsCol: 2,
              type: "switch",
            },
          ],
        },
        {
          xsCol: 12,
          name: "Notes",
          label: "Comments",
          type: "textarea",
          rows: 5
        },
      ],
    },
  ];
}

function SearchFilterReducer(state, action) {
  if (action.type === FormActions.INPUT_CHANGED) {
    return { ...state, [action.payload.name]: action.payload.value };
  }
  if (action.type === FormActions.LOAD_DATA) {
    return { ...state, ...action.payload, _ts_key: Date.now() };
  }
  if (action.type === FormActions.RESET_FORM) {
    return { ...SearchFilterDefaults, _ts_key: Date.now() };
  }
  return state;
}

const SearchFilterDefaults = {
  Sampled: toIsoFormat(new moment()),
  LaboratoryId: 1,
  ReportType: 1,
};

const GetFormButtons = (saveClick) => [
  {
    label: "Save",
    onClick: saveClick,
  },
];
